(() => {
  const COOKIE_NAME = 'age_gate_verified';
  const COOKIE_MAX_AGE_SECONDS = 24 * 60 * 60;

  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop().split(';').shift();
    }
    return null;
  };

  const setCookie = (name, value, maxAgeSeconds) => {
    const parts = [
      `${name}=${encodeURIComponent(value)}`,
      'path=/'
    ];
    if (maxAgeSeconds && maxAgeSeconds > 0) {
      parts.push(`max-age=${maxAgeSeconds}`);
    }
    document.cookie = parts.join('; ');
  };

  const calculateAge = (day, month, year) => {
    const today = new Date();
    const birthDate = new Date(year, month - 1, day);

    if (
      birthDate.getFullYear() !== year ||
      birthDate.getMonth() !== month - 1 ||
      birthDate.getDate() !== day
    ) {
      return -1;
    }

    let age = today.getFullYear() - year;
    const m = today.getMonth() - (month - 1);
    if (m < 0 || (m === 0 && today.getDate() < day)) {
      age -= 1;
    }
    return age;
  };

  const initAgeGate = () => {
    const modal = document.querySelector('.popup-age-verification');
    if (!modal) return;

    const designMode = modal.dataset.designMode === 'true';
    const legalAge = parseInt(modal.dataset.legalAge || '18', 10);

    if (!designMode && getCookie(COOKIE_NAME)) {
      // Ensure modal stays hidden if already verified
      modal.classList.remove('active');
      modal.style.display = 'none';
      return;
    }

    const dayInput = modal.querySelector('[name=\"day\"]');
    const monthInput = modal.querySelector('[name=\"month\"]');
    const yearInput = modal.querySelector('[name=\"year\"]');
    const countrySelect = modal.querySelector('[data-age-gate-country]');
    const submitButton = modal.querySelector('[data-age-gate-submit]');
    const errorElm = modal.querySelector('[data-age-gate-error]');
    const contentElm = modal.querySelector('[data-age-gate-content]');
    const underageElm = modal.querySelector('[data-age-gate-underage]');
    const closeButton = modal.querySelector('[data-js-close]');
    const formElm = modal.querySelector('.age-gate__form');

    if (!dayInput || !monthInput || !yearInput || !submitButton || !errorElm || !underageElm || !closeButton || !formElm) {
      return;
    }

    if (countrySelect) {
      countrySelect.addEventListener('change', () => {
        const url = countrySelect.value;
        if (url) window.location.href = url;
      });
    }

    const messages = {
      incomplete: modal.getAttribute('data-error-incomplete') || 'Please enter your full date of birth (DD MM YYYY).',
      invalid: modal.getAttribute('data-error-invalid') || 'Please enter a valid date of birth.'
    };

    const showError = (message) => {
      errorElm.textContent = message;
      errorElm.style.display = 'block';
    };

    const clearError = () => {
      contentElm.style.display = 'block';
      errorElm.textContent = '';
      errorElm.style.display = 'none';
    };

    submitButton.addEventListener('click', () => {
      clearError();

      const day = parseInt(dayInput.value, 10);
      const month = parseInt(monthInput.value, 10);
      const year = parseInt(yearInput.value, 10);

      if (isNaN(day) || isNaN(month) || isNaN(year)) {
        showError(messages.incomplete);
        return;
      }

      const age = calculateAge(day, month, year);

      if (age < 0) {
        showError(messages.invalid);
        return;
      }

      if (age < legalAge) {
        contentElm.style.display = 'none';
        formElm.style.display = 'none';
        underageElm.style.display = 'block';
        return;
      }

      setCookie(COOKIE_NAME, 'true', COOKIE_MAX_AGE_SECONDS);
      closeButton.click();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAgeGate);
  } else {
    initAgeGate();
  }
})();

